var map = {
	"./elmo-shrug.gif": 2077,
	"./friends-joey.gif": 4576,
	"./mob-psycho-rage.gif": 6866,
	"./okay-onepunchman.gif": 7874,
	"./shrug.gif": 8504,
	"./the-office-karen-filippelli.gif": 3630,
	"./uzaki-chan-uzaki.gif": 8555,
	"./vampire-diaries-the-vapire-diaries.gif": 1991,
	"./woody-woodpecker-shrug-shoulders.gif": 6056
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7637;